<div class="reward-token-card__top-combined">
    <div class="reward-token-card__header-combined">
        <ng-container [ngTemplateOutlet]="vipBadgeTemplate" />
        <div class="reward-token-card__title reward-token-card__title-combined">
            {{ tokenTitle }}
        </div>
        @if (!isRewardDrawerEnabled) {
            @if (isRewardBannerView) {
                <div class="reward-token-card__returns">{{ oddsBoostPercentageDetails }}</div>
            } @else {
                @if (odds$ | async; as odds) {
                    <div class="odds-boost-card__odds">
                        <ng-container *ngTemplateOutlet="cardOdds; context: { odds: odds }"></ng-container>
                    </div>
                }
            }
        }
    </div>
    <div class="reward-token-card-category-link">
        <bs-reward-token-categories
            [categories]="tokenCategories"
            [isRewardDrawerEnabled]="isRewardDrawerEnabled"
            [tokenFilter]="token.filter"
            [betType]="betType.length > 0 ? betType[0].value : ''"></bs-reward-token-categories>
        @if (termsAndConditionLinkText) {
            <bs-reward-token-card-info-link
                [token]="token"
                [withArrow]="false"
                [overrideLinkTitleHtml]="termsAndConditionLinkText"></bs-reward-token-card-info-link>
        }
    </div>
</div>
@if (tokenLimitations.length) {
    <div class="odds-boost-card__link-group">
        <bs-reward-token-limitations [limitations]="tokenLimitations" [isRewardDrawerEnabled]="isRewardDrawerEnabled"></bs-reward-token-limitations>
    </div>
}

@if (showPayout) {
    <div class="reward-token-card__payout-details">
        @if (!isRewardDrawerEnabled) {
            <span class="reward-token-card__payout-title">{{ sitecore.crmTokens.oddsBoost.card.BoostedWinningsPayout }}&nbsp;</span>
        }
        @if (isRewardDrawerEnabled) {
            <span class="reward-token-card__payout-title-epcot reward-token-card__payout-title"> {{ tokenPayoutTitle }}&nbsp; </span>
        }
        <span class="reward-token-card__payout-details__content"
            >{{ payoutDetails }}
            @if (isRewardDrawerEnabled && (isMinLegsValid$ | async) && odds$ | async; as odds) {
                @if (isEpcotEnabled) {
                    <span>&lpar;</span>
                    <ng-container *ngTemplateOutlet="cardOdds; context: { odds: odds }"></ng-container>
                    <span>&rpar;</span>
                } @else {
                    <span class="reward-token-card_separator-new-reward-drawer">&nbsp;</span>
                    <span
                        >{{ this.sitecore.crmTokens.oddsBoost.card.BoostedOddsTemplate }}
                        <ng-container *ngTemplateOutlet="cardOdds; context: { odds: odds }"></ng-container>
                    </span>
                }
            }
        </span>
    </div>
}
<div [class.reward-token-footer-details]="applyRemoveButtonsShowHide()">
    <bs-reward-token-footer-details
        [expireTokenReward]="expireTokenReward"
        [token]="token"
        [promoHubUrlTokenType]="promoHubUrlTokenType"
        [isRewardBannerView]="isRewardBannerView"
        [tokenTitle]="tokenTitle"
        [tokenCategories]="tokenCategories"></bs-reward-token-footer-details>
    @if (applyRemoveButtonsShowHide()) {
        <button ds-button size="small" variant="outline" kind="secondary">
            {{ applyOrRemoveTokenText }}
        </button>
    }
</div>

<ng-template #cardOdds let-odds="odds">
    @if (odds) {
        <span class="odds-boost-card__old-odds" [@oldValueAnimation]="odds">{{
            odds | bsOddsFormatter: oddsDisplayFormat : false : false : null : maxDecimalPlaces : true
        }}</span>
    }
    @if (boostedOdds) {
        <span class="odds-boost-card__new-odds" [@newValueAnimation]="boostedOdds">{{
            boostedOdds | bsOddsFormatter: oddsDisplayFormat : false : false : null : maxDecimalPlaces : true
        }}</span>
    }
</ng-template>
